import { Route, Routes } from "react-router";

import NotFoundPage from "@/app/NotFoundPage";
import DashboardPage from "@/features/dashboard/DashboardPage";
import ProductStockDetailRoute from "@/features/product-stocks/ProductStockDetailRoute";
import ProductStocksPage from "@/features/product-stocks/ProductStocksPage";
import ProductsPage from "@/features/products/ProductsPage";
import ProfilePage from "@/features/profile/ProfilePage";
import ProvisionStockDetailRoute from "@/features/provision-stocks/ProvisionStockDetailRoute";
import ProvisionStocksPage from "@/features/provision-stocks/ProvisionStocksPage";
import ProvisionsPage from "@/features/provisions/ProvisionsPage";
import RecipesPage from "@/features/recipes/RecipesPage";
import VendingPage from "@/features/vending/VendingPage";

/** Paths are shared with the sidebar, so they live in one place. */
export const ROUTES = {
  dashboard: "/",
  provisions: "/provisions",
  provisionStocks: "/provisional-stocks",
  products: "/products",
  productStocks: "/product-stocks",
  recipes: "/recipes",
  vending: "/vending",
  profile: "/profile",
  /** Handled in App, above the auth check — not in AppRoutes below. */
  about: "/about",
} as const;

export function AppRoutes() {
  return (
    <Routes>
      <Route path={ROUTES.dashboard} element={<DashboardPage />} />
      <Route path={ROUTES.provisions} element={<ProvisionsPage />} />
      <Route path={ROUTES.provisionStocks} element={<ProvisionStocksPage />} />
      <Route path={`${ROUTES.provisionStocks}/:id`} element={<ProvisionStockDetailRoute />} />
      <Route path={ROUTES.products} element={<ProductsPage />} />
      <Route path={ROUTES.productStocks} element={<ProductStocksPage />} />
      <Route path={`${ROUTES.productStocks}/:id`} element={<ProductStockDetailRoute />} />
      <Route path={ROUTES.recipes} element={<RecipesPage />} />
      <Route path={ROUTES.vending} element={<VendingPage />} />
      <Route path={ROUTES.profile} element={<ProfilePage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
